import React from 'react';
import { motion } from 'framer-motion';
import NotificationBell from './NotificationBell';

const Header = ({ title, onNavigate }) => {
  return (
    <motion.header 
      className="bg-white border-b border-gray-200 px-6 py-4 shadow-sm"
      initial={{ y: -20, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.5 }}
    >
      <div className="flex items-center justify-between">
        <div>
          <h2 className="text-2xl font-bold text-gray-900">{title}</h2>
          <p className="text-gray-500 mt-1">
            {new Date().toLocaleDateString('es-ES', { 
              weekday: 'long', 
              year: 'numeric', 
              month: 'long', 
              day: 'numeric' 
            })}
          </p>
        </div>

        <div className="flex items-center gap-4">
          {/* Notifications */}
          <NotificationBell onNavigate={onNavigate} />
        </div>
      </div>
    </motion.header>
  );
};

export default Header;